import { Component } from '@angular/core';

@Component({
    selector: 'app-prepare',
    templateUrl: './prepare.component.html',
    styleUrls: ['./prepare.component.scss']
})
export class PrepareComponent {
    constructor() {}
}
